'use client';

import Carousel3D from '@/components/ui/Carousel3D';
import Icon from '@/components/ui/AppIcon'; // Keep Icon import as Carousel3D might use it
import MobileServicesOverview from './MobileServicesOverview';

const ServicesOverview = () => {
    const services = [
        {
            id: 1,
            title: 'Web Development Studio',
            description: 'Architecting high-performance digital platforms that convert visitors into revenue. Built for speed, security, and scale.',
            icon: 'CodeBracketIcon',
            features: [
                'Custom Web Applications',
                'Responsive Design',
                'Performance Optimization',
                'UI/UX Excellence',
                'Scalable Cloud Architecture',
                'Secure API Integration',
                'E-commerce Solutions',
                'Progressive Web Apps (PWA)'
            ],
            link: '/services',
            image: '/web_development.webp',
            gradient: 'from-blue-600 to-indigo-600',
            accent: 'text-indigo-600',
            bg: 'bg-indigo-50/50',
        },
        {
            id: 2,
            title: 'Mobile App Development',
            description: 'Engaging native experiences that put your brand in your customer\'s pocket. Seamless performance across iOS and Android.',
            icon: 'DevicePhoneMobileIcon',
            features: [
                'Native Android & iOS Apps',
                'Cross-Platform (Flutter/React)',
                'App Store Optimization',
                'Mobile-First Design',
                'Real-time Features & Chat',
                'Push Notifications',
                'Offline Capabilities',
                'Wearable App Integration'
            ],
            link: '/services',
            image: '/Mobile_App_Development.webp',
            gradient: 'from-violet-600 to-fuchsia-600',
            accent: 'text-violet-600',
            bg: 'bg-violet-50/50',
        },
        {
            id: 3,
            title: 'Brand Visibility Lab',
            description: 'Dominate local search with data-backed strategies. We turn your online reputation into your strongest growth asset.',
            icon: 'ChartBarIcon',
            features: [
                'Google Business Profile',
                'Advanced SEO Strategy',
                'Reputation Management',
                'Local Search Dominance',
                'Competitor Analysis',
                'Conversion Optimization',
                'Content Marketing',
                'Analytics & Reporting'
            ],
            link: '/brand-visibility-lab',
            image: '/brand_visibility_lab.webp',
            gradient: 'from-emerald-500 to-teal-600',
            accent: 'text-teal-600',
            bg: 'bg-teal-50/50',
        }
    ];

    return (
        <section className="py-24 bg-slate-50 min-h-screen flex flex-col justify-center relative overflow-hidden">

            {/* Background Effects */}
            <div className="absolute top-0 right-0 w-[50vh] h-[50vh] bg-blue-100/40 rounded-full blur-[100px] pointer-events-none" />
            <div className="absolute bottom-0 left-0 w-[50vh] h-[50vh] bg-violet-100/40 rounded-full blur-[100px] pointer-events-none" />
            <div className="absolute inset-0 bg-[url('/grid.svg')] bg-center [mask-image:linear-gradient(180deg,white,rgba(255,255,255,0))] opacity-[0.03] pointer-events-none" />

            {/* Desktop View */}
            <div className="hidden lg:block relative z-10">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full mb-12 relative z-10">
                    <div className="text-center max-w-3xl mx-auto">
                        <h2 className="text-3xl sm:text-5xl font-black text-slate-900 tracking-tight mb-4">
                            Complete Digital <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-violet-600">Ecosystems</span>
                        </h2>
                        <p className="text-lg text-slate-600">
                            Explore our core pillars of digital excellence.
                        </p>
                    </div>
                </div>

                {/* 3D Carousel */}
                <div className="w-full relative z-10">
                    <Carousel3D
                        items={services}
                        cardWidth={450}
                        cardHeight={700}
                        perspective={1200}
                        gap={200} // Increased gap for better text visibility in 3D
                    />
                </div>
            </div>

            {/* Mobile View */}
            <div className="block lg:hidden relative z-10">
                <MobileServicesOverview services={services} />
            </div>
        </section>
    );
};

export default ServicesOverview;
